import axios from "axios";
import API from "../helpers/api";
import FileSaver from "file-saver";
import Moment from "moment";
import swal from "sweetalert";
import { showLoader, hideLoader } from "./PageLoaderAPI";

let user = JSON.parse(localStorage.getItem("currentUser"));

export const getShipnameList = (id) => {
  let url = `${API.shipNames}?email=${user.email}`;
  return (dispatch) => {
    // dispatch(showLoader());
    axios
      .get(url)
      .then((response) => {
        if (id !== "" || id !== undefined) {
          var ID = parseInt(id)
          var Result = response.data.filter((item, index) => (item.shipID === ID))
          dispatch({
            type: "getshipnameSuccess",
            data: Result,
          });
        }
        dispatch({
          type: "getshipListSuccess",
          data: response.data,
        });
        // dispatch(hideLoader());
      })
      .catch((error) => {
        dispatch({
          type: "getshipListFailure",
          error: "ERROR",
        });
        // dispatch(hideLoader());
      });
  };
};

export const getTimezonenameList = () => {
  let url = `${API.TimeZoneList}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {

        dispatch({
          type: "gettimezoneListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "gettimezoneListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getDevicenameList = () => {
  let url = `${API.deviceNames}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {

        dispatch({
          type: "getdeviceListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getshipListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getShipDetails = (shipID) => {
  let url = `${API.GetShipDetails}?ShipID=${shipID}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {

        dispatch({
          type: "getShipManagementDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getShipManagementDetailFailure",
          error: "ERROR",
        });
      });
  };
};
export const getCompanynameList = () => {

  let url = `${API.companyNames}?email=${user.email}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {

        dispatch({
          type: "getCompanyListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getCompanyListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getCrewSearchList = (item, pgnumber, shipMail, id) => {
  let emailShip;
  if (shipMail) {
    emailShip = shipMail;
  } else {
    emailShip = user.email;
  }
  let url = `${API.SearchCrew}?mail=${emailShip ?? ""}&ShipId=${item.ShipId ?? 0}&CrewId=${item.crewId ?? ""}&ShipName=${item.shipName}&CrewName=${item.crewName}&isPass=${item.isPass ?? false}&showAllResult=${item.showAllResult ?? true}&ToDate=${item.toDate}&FromDate=${item.fromDate}&isAll=${item.isAll}&ExcludeRefuse=${item.ExcludeRefuse}&PageNumber=${pgnumber ?? 1}&PageSize=${item.PageSize ?? 25}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getCrewListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getCrewListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getCrewSearchList1 = (item, pgnumber, shipMail, id) => {
  let emailShip;
  if (shipMail) {
    emailShip = shipMail;
  } else {
    emailShip = user.email;
  }
  let url = `${API.SearchCrew}?mail=${emailShip ?? ""}&ShipId=${item.ShipId ?? 0}&CrewId=${item.crewId ?? ""}&ShipName=${item.shipName}&CrewName=${item.crewName}&isPass=${item.isPass ?? false}&showAllResult=${item.showAllResult ?? true}&ToDate=${item.toDate}&FromDate=${item.fromDate}&isAll=${item.isAll}&ExcludeRefuse=${item.ExcludeRefuse}&PageNumber=${pgnumber ?? 1}&PageSize=${item.PageSize ?? 25}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getCrewListSuccess",
          data: response.data,
        });
        // getShipnameList();
      })
      .catch((error) => {
        dispatch({
          type: "getCrewListFailure",
          error: "ERROR",
        });
      });
  };
};

export const ExportExcelCrew = (item, pgnumber) => {
  let url = `${API.ExportCrew}?mail=${user.email ?? ""}&ShipId=${item.ShipId ?? 0}&CrewId=${item.crewId ?? ""}&ShipName=${item.shipName}&CrewName=${item.crewName}&isPass=${item.isPass ?? false}&showAllResult=${item.showAllResult ?? true}&ToDate=${item.toDate}&FromDate=${item.fromDate}&isAll=${item.isAll}&ExcludeRefuse=${item.ExcludeRefuse}&PageNumber=${pgnumber ?? 1}&PageSize=${item.PageSize ?? 25}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = '';
        let FileName = "Report" + "_" + Moment(new Date()).format("DD-MM-YYYY HH:mm")
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, FileName);
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 500) {
          swal("Error!", "Something went wrong. Please try again.", "warning");
        }
        dispatch({
          type: "DownloadFailure",
          error: "ERROR",
        });
      });
  };
};

export const getCompanyUsersList = (name) => {
  let url = `${API.companyUserNames}?clientName=${name}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getCompanyUsersListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getCompanyUsersListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getClientUsersList = (item) => {
  let url = `${API.ClientUserlist}?ClientName=${item}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {

        let fleetManager =
          response.data &&
          response.data.filter((r) => r.role === "fleetmanager");
        let techSuperintendent =
          response.data &&
          response.data.filter((r) => r.role === "superintendent");
        let techExecutive =
          response.data &&
          response.data.filter((r) => r.role === "technicalexecutive");
        dispatch({
          type: "fleetManagerListSuccess",
          data: fleetManager,
        });
        dispatch({
          type: "techSuperintendentListSuccess",
          data: techSuperintendent,
        });
        dispatch({
          type: "techExecutiveListSuccess",
          data: techExecutive,
        });
        dispatch({
          type: "getClientUserListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClientUserListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getCrewSearchListDidmount = (item, pgnumber, shipMail, id) => {
  let emailShip;
  if (shipMail) {
    emailShip = shipMail;
  } else {
    emailShip = user.email;
  }
  let url = `${API.SearchCrew}?mail=${emailShip ?? ""}&ShipId=${item.ShipId ?? 0}&CrewId=${item.crewId ?? ""}&ShipName=${item.shipName}&CrewName=${item.crewName}&isPass=${item.isPass ?? false}&showAllResult=${item.showAllResult ?? true}&ToDate=${item.toDate}&FromDate=${item.fromDate}&isAll=${item.isAll}&ExcludeRefuse=${item.ExcludeRefuse}&PageNumber=${pgnumber ?? 1}&PageSize=${item.PageSize ?? 25}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getCrewListSuccess",
          data: response.data,
        });
        dispatch(getShipnameList());
        dispatch(getTimezonenameList());
      })
      .catch((error) => {
        dispatch({
          type: "getCrewListFailure",
          error: "ERROR",
        });
      });
  };
};
